import React from 'react';
import logoImage from '../../../images/Hz_W_Co.png';

const LogoCelledHorizontal = () => {
  return (
    <img
      src={logoImage}
      alt="Cell-Ed Logo"
      style={{ height: '48px', width: 'auto' }}
    />
  );
};

export default LogoCelledHorizontal;
